import Page from "./cu/page";
import Users from "./cu/users";
import Form from "./cu/form";
import AvailableContracts from "./cosmote/availableContracts";
import ModalForPackages from "./cosmote/modalForPackages";
import InfoPanel from "./cosmote/infoPanel";
import InfoPopUp from "./cosmote/InfoPopUp";
import Footer from "./cosmote/footer";
import Main from "./cosmote";
import Header from "./cosmote/header";
import CreditSubmit from "./cosmote/creditSubmitService";
import SubmitPaymentInfo from "./cosmote/submitPaymentInfo";
import ModalForTerms from "./cosmote/modalForTerms";
import ModalForTermVat from "./cosmote/modalForTermVat";
import ActivationPage from "./cosmote/activate";
import ModalForActivation from "./cosmote/modalForActivation";
import ThankYou from "./cosmote/thank_you_page";
import ErrorPage from "./cosmote/error503";
import HybridWallet from "./cosmote/hybrid_wallet";
import Payment from "./cosmote/payment";
import ModalForCredit from "./cosmote/modalTermsForCreditCard";

const Modules = {
  page: Page,
  users: Users,
  form: Form,
  cosmoteAvailableContracts: AvailableContracts,
  modalForPackages: ModalForPackages,
  modalForTerms: ModalForTerms,
  modalForTermVat: ModalForTermVat,
  infoPanel: InfoPanel,
  infoPopUp: InfoPopUp,
  footer: Footer,
  main: Main,
  header: Header,
  creditSubmitService: CreditSubmit,
  submitPaymentInfo: SubmitPaymentInfo,
  activatePage: ActivationPage,
  modalForActivation: ModalForActivation,
  thankYou: ThankYou,
  errorPage: ErrorPage,
  hybridWallet: HybridWallet,
  payment: Payment,
  modalForCredit: ModalForCredit
};

export default Modules;
